import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import AnalyticsTracker from './AnalyticsTracker'
import Header from './components/Header'
import Footer from './components/Footer'

const Home = lazy(() => import('./pages/Home'))
const About = lazy(() => import('./pages/About'))
const Services = lazy(() => import('./pages/Services'))
const Partners = lazy(() => import('./pages/Partners'))
const Mission = lazy(() => import('./components/Mission'))
const OurTeam = lazy(() => import('./components/OurTeam'))

function App() {
  return (
    <Router>
      <AnalyticsTracker />
      <div className="App w-full min-w-0 max-w-full overflow-x-clip">
        <Header />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/our-mission" element={<Mission />} />
            <Route path="/our-team" element={<OurTeam />} />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </Router>
  )
}

export default App

